<template>
  <a
    :href="endpoint"
    class="relative button flex justify-start items-center m-1"
    target="_blank"
    :class="css"
    v-if="isLink"
  >
    <font-awesome-icon
      :icon="icon"
      v-if="!loading && !iconAfter && icon"
      fixed-width
    />
    <slot>
      <span
        v-html="label"
        class="w-full whitespace-no-wrap leading-none"
        :class="iconAfter ? 'pr-2 text-left' : 'pl-2 text-center'"
      ></span>
    </slot>
    <font-awesome-icon
      :icon="icon"
      v-if="!loading && iconAfter && icon"
      fixed-width
    />
  </a>
  <router-link
    class="relative button flex justify-start items-center m-1"
    :class="css"
    :to="route"
    v-else-if="isRouterLink"
  >
    <font-awesome-icon
      :icon="icon"
      v-if="!loading && !iconAfter && icon"
      fixed-width
    />
    <font-awesome-icon
      icon="spinner"
      spin
      v-if="loading && !iconAfter"
      fixed-width
    />
    <slot>
      <span
        v-html="label"
        class="w-full whitespace-no-wrap leading-none"
        :class="iconAfter ? 'pr-2 text-left' : 'pl-2 text-center'"
      ></span>
    </slot>
    <font-awesome-icon
      :icon="icon"
      v-if="!loading && iconAfter && icon"
      fixed-width
    />
    <font-awesome-icon
      icon="spinner"
      spin
      v-if="loading && iconAfter"
      fixed-width
    />
  </router-link>
  <button
    class="relative button flex justify-start items-center m-1"
    :class="css"
    @click="click"
    v-else
  >
    <font-awesome-icon
      :icon="icon"
      v-if="!loading && !iconAfter && icon"
      fixed-width
    />
    <font-awesome-icon
      icon="spinner"
      spin
      v-if="loading && !iconAfter"
      fixed-width
    />
    <slot>
      <span
        v-html="label"
        class="w-full whitespace-no-wrap leading-none"
        :class="iconAfter ? 'pr-2 text-left' : 'pl-2 text-center'"
      ></span>
    </slot>
    <font-awesome-icon
      :icon="icon"
      v-if="!loading && iconAfter && icon"
      fixed-width
    />
    <font-awesome-icon
      icon="spinner"
      spin
      v-if="loading && iconAfter"
      fixed-width
    />
  </button>
</template>

<script>
export default {
  props: {
    icon: {
      type: [Object, String, Array, Boolean],
      default: "info-circle",
    },
    label: {
      type: String,
      default: "",
    },
    action: {
      type: String,
      default: "action",
    },
    size: {
      type: String,
      default: "base",
    },
    iconAfter: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
      required: false,
    },
    active: {
      type: Boolean,
      default: true,
      required: false,
    },
    endpoint: {
      type: String,
      default: null,
      required: false,
    },
    route: {
      default: null,
      required: false,
    },
  },
  methods: {
    click() {
      if (!this.loading) {
        this.$emit("click");
      }
    },
  },
  computed: {
    sizeCss() {
      return "button-" + this.size;
    },
    css() {
      if (!this.active) {
        return "cursor-not-allowed inactive " + this.sizeCss;
      }

      return this.action + " " + this.sizeCss;
    },
    isLink() {
      return this.endpoint !== null;
    },
    isRouterLink() {
      return this.route !== null;
    },
  },
};
</script>
